/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const BANNERTYPEENUM = {
  HERO_HEADER: "HERO_HEADER",
  SEARCH: "SEARCH",
  OVERVIEW: "OVERVIEW"
} as const;
export type BANNERTYPEENUM = typeof BANNERTYPEENUM[keyof typeof BANNERTYPEENUM];

export function BANNERTYPEENUMFromJSON(json: any): BANNERTYPEENUM {
  return BANNERTYPEENUMFromJSONTyped(json, false);
}

export function BANNERTYPEENUMFromJSONTyped(json: any, ignoreDiscriminator: boolean): BANNERTYPEENUM {
  return json as BANNERTYPEENUM;
}

export function BANNERTYPEENUMToJSON(value?: BANNERTYPEENUM | null): any {
  return value as any;
}
